<!--Title Section-->
<br>
<app-title-jumbo title="Funds" comment="Thousands of funds scoured so that you have the most interesting set of data at your fingertips"></app-title-jumbo>

<div class="my-container">

  <!--Synthesis Section-->
  <section>
    <div class="container">
      <div class="offset-1 col-10">
        <!-- Card deck -->
        <div class="card-deck">

          <!-- Card Funds Screener -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/034.png"
                   alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='screener'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-compress-arrows-alt"></i> Overview</h4>
              <!--Text-->
              <p class="dl-text-color">More than 2,000 funds are available in the database. Analytics highlight differences between funds.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button (click)="selectBlock='screener'">Overview</app-button>

            </div>

            <!--Card footer-->
            <div *ngIf="selectBlock==''" class="card-footer text-right">
              <small class="text-muted">{{ '2000-01-01' | date:'d MMM y' }} - {{ '2020-12-31' | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Funds Screener -->

          <!-- Card Create Watchlist -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/035.png"
                   alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='create-watchlist'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-th-large"></i> Create a Watchlist</h4>
              <!--Text-->
              <p class="dl-text-color">Select funds to create watchlists that will be relevant during the investment process.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button (click)="selectBlock='create-watchlist'">Create Watchlist</app-button>

            </div>

            <!--Card footer-->
            <div *ngIf="selectBlock==''" class="card-footer text-right">
              <small class="text-muted">{{ '2000-01-01' | date:'d MMM y' }} - {{ '2020-12-31' | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Create Watchlist -->

          <!-- Card Watchlists -->
          <div class="card mb-4">

            <!--Card image-->
            <div *ngIf="selectBlock==''" class="view overlay">
              <img class="card-img-top" src="assets/img/036.png"
                   alt="Card image cap">
            </div>

            <!--Card content-->
            <div class="card-body">

              <!--Title-->
              <h4 class="card-title" [ngStyle]="{'color': selectBlock=='watchlists'? 'rgb(118,168,255)' : 'grey'}"><i class="fas fa-th-list"></i> My Watchlists</h4>
              <!--Text-->
              <p class="dl-text-color">Watchlists are now ready to be used. Should you have any modification to apply, you can still manage them.</p>
              <!-- Provides extra visual weight and identifies the primary action in a set of buttons -->
              <app-button (click)="selectBlock='watchlists'">Manage</app-button>

            </div>

            <!--Card footer-->
            <div *ngIf="selectBlock==''" class="card-footer text-right">
              <small class="text-muted">{{ '2000-01-01' | date:'d MMM y' }} - {{ '2020-12-31' | date:'d MMM y' }}</small>
            </div>

          </div>
          <!-- Card Watchlists -->

        </div>
        <!-- Card deck -->
      </div>
    </div>
  </section>
  <!--Synthesis Section-->

  <!--Peers Section-->
  <section  [ngClass]="{'section': true, 'd-none': selectBlock!='screener'}">
    <div class="container">
      <div class="col-12">
        <app-peers-widget></app-peers-widget>
      </div>
    </div>
  </section>
  <!--Peers Section-->

  <!--Create Section-->
  <div class="container" [ngClass]="{'d-none': selectBlock!='create-watchlist'}">
    <div class="offset-1 col-10">

      <div class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-12 text-left">
                    <h5 class=" card-category">Funds</h5>
                    <h2 class=" card-title"><i class="fas fa-th-large"></i> Create a Watchlist</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">

                <div class="row">
                  <div class="col-4 text-center" style="line-height: 30px">
                    <span style="color: grey">Selection &nbsp;&nbsp;&nbsp;
                      <mat-form-field>
                        <mat-select [(value)]="bestFitSelection" (selectionChange)="bestFitSelectionChange()">
                          <mat-option value="top18">Top 18</mat-option>
                          <mat-option value="watchlists" [disabled]="watchlists==undefined || watchlists.length==0">Watch Lists</mat-option>
                          <mat-option value="selected">Show selected only</mat-option>
                          <mat-option value="all">All</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </span>
                    <br>
                  </div>
                  <div class="col-4 text-center" style="line-height: 30px">
                    <mat-form-field *ngIf="bestFitSelection=='all'">
                      <mat-label>Filter</mat-label>
                      <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Diversified">
                    </mat-form-field>
                    <mat-form-field *ngIf="bestFitSelection=='watchlists'">
                      <mat-select [(value)]="selectedWatchlist" (selectionChange)="bestFitSelectionChange()">
                        <mat-option *ngFor="let watchlist of watchlists" [value]="watchlist">{{ watchlist.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <br>
                  </div>
                  <div class="col-4 text-center" style="line-height: 30px">
                    <span style="color: grey">View &nbsp;&nbsp;&nbsp;
                      <mat-form-field>
                        <mat-select value="factor-intensity" (selectionChange)="bestFitViewChange($event.value)">
                          <mat-option value="factor-intensity">Intensity</mat-option>
                          <mat-option value="returns">Returns</mat-option>
                          <mat-option value="sharpe-ratio">Sharpe ratio</mat-option>
                          <mat-option value="max-drawdown">Drawdown</mat-option>
                          <mat-option value="esg">ESG</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </span>
                  </div>
                </div>

                <!-- Table -->
                <div class="mat-elevation-z8">
                  <table mat-table [dataSource]="dataSource" matSort>

                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                      <th class="checkbox-cell" mat-header-cell *matHeaderCellDef></th>
                      <td class="checkbox-cell" mat-cell *matCellDef="let row">
                        <mat-checkbox (change)="onProductSelectionChange($event, row)"
                                      [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                      </td>
                    </ng-container>

                    <!-- Frequency Column -->
                    <ng-container matColumnDef="frequency">
                      <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:30px"></th>
                      <td mat-cell *matCellDef="let element">
                        <app-frequency-badge [frequency]="element.frequency.alias"></app-frequency-badge>
                      </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                      <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                      <td class="ellipsis" mat-cell *matCellDef="let element">
                        <span mdbTooltip="{{ element.name }}">{{ element.name }}</span>
                      </td>
                    </ng-container>

                    <!-- Currency Column -->
                    <ng-container matColumnDef="currency">
                      <th class="center-header" mat-header-cell *matHeaderCellDef style="width:90px">Currency</th>
                      <td mat-cell *matCellDef="let element" style="width:90px">{{ element.currency.alias }}</td>
                    </ng-container>

                    <!-- Investment Zone Column -->
                    <ng-container matColumnDef="investment_zone">
                      <th class="center-header" mat-header-cell *matHeaderCellDef style="width:120px">Zone</th>
                      <td mat-cell *matCellDef="let element" style="width:120px">{{ element.investment_zone.name }}</td>
                    </ng-container>

                    <!-- Intensity Column -->
                    <ng-container matColumnDef="factor_intensity">
                      <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">Intensity</th>
                      <td mat-cell *matCellDef="let element" style="width:90px">{{ element.factor_intensity | number:'1.3-3' }}</td>
                    </ng-container>

                    <!-- Returns Column -->
                    <ng-container matColumnDef="returns">
                      <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">Returns</th>
                      <td mat-cell *matCellDef="let element" style="width:90px">{{ element.returns | percent:'.1' }}</td>
                    </ng-container>

                    <!-- Sharpe ratio Column -->
                    <ng-container matColumnDef="sharpe_ratio">
                      <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">Sharpe ratio</th>
                      <td mat-cell *matCellDef="let element" style="width:90px">{{ element.sharpe_ratio | percent:'.1' }}</td>
                    </ng-container>

                    <!-- Max Drawdown Column -->
                    <ng-container matColumnDef="maximum_drawdown">
                      <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">Drawdown</th>
                      <td mat-cell *matCellDef="let element" style="width:90px">{{ element.maximum_drawdown | percent:'.1' }}</td>
                    </ng-container>

                    <!-- ESG Column -->
                    <ng-container matColumnDef="esg">
                      <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">ESG</th>
                      <td mat-cell *matCellDef="let element" style="width:90px">{{ element.esg | number:'1.0-0' }}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>

                  <mat-paginator [pageSizeOptions]="[10,20,50]" showFirstLastButtons></mat-paginator>

                  <br>
                </div>
                <!-- Table -->

                <div class="row">
                  <div class="offset-2 col-4 text-center" style="line-height: 30px">
                    <mat-form-field class="w-100">
                      <mat-label>Watchlist Name</mat-label>
                      <input matInput [(ngModel)]="watchlistName" placeholder="Ex. My Watchlist">
                    </mat-form-field>
                  </div>
                  <div class="col-4 text-center" style="line-height: 30px">
                    <app-button [disabled]="emptySelection || watchlistName==''" (click)="onWatchlistCreate()">Create Watchlist</app-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!--Create Section-->

  <!--Watchlists Section-->
  <div class="container" [ngClass]="{'d-none': selectBlock!='watchlists'}">
    <div class="offset-1 col-10">

      <div class=" content">
        <div class=" row">
          <div class=" col-12">
            <div class=" card card-chart">
              <div class=" card-header">
                <div class=" row">
                  <div class=" col-12 text-left">
                    <h5 class=" card-category">Funds</h5>
                    <h2 class=" card-title"><i class="fas fa-th-list"></i> My Watchlists</h2>
                  </div>
                </div>
              </div>
              <div class="card-body" *ngIf="watchlists">

                <div *ngFor="let watchlist of watchlists; let i = index">
                  <mat-accordion>
                    <mat-expansion-panel [expanded]="watchlist.open"
                                        (opened)="watchlist.open = true"
                                        (closed)="watchlist.open = false">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          {{ watchlist.name }}
                        </mat-panel-title>
                        <mat-panel-description *ngIf="!watchlist.open">
                          {{ watchlist.creation_date | date:'d MMM y' }} - {{ watchlist.nb_products }} products
                        </mat-panel-description>
                      </mat-expansion-panel-header>

                      <div class="row">
                        <div class="col-12" style="line-height: 30px">

                          <!-- Weighting table -->
                          <table mdbTable small="true" *ngIf="watchlistsProducts && watchlistsProducts[i]">
                            <thead>
                              <tr>
                                <th scope="col">Product Name</th>
                                <th scope="col" style="width:90px">Currency</th>
                                <th scope="col" style="width:150px">Zone</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let product of watchlistsProducts[i]">
                                <td class="ellipsis align-middle" scope="row">
                                  <span mdbTooltip="{{ product.name }}">{{ product.name }}</span>
                                </td>
                                <td style="width:90px" class="align-middle"><span>{{ product.currency.alias }}</span></td>
                                <td style="width:150px" class="align-middle"><span>{{ product.investment_zone.name }}</span></td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- Weighting table -->

                        </div>
                        <div class="col-12 text-center">
                          <app-button color="danger" (click)="onDeleteWatchlist(watchlist.id)">Delete watchlist</app-button>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                  <br *ngIf="i!=watchlists.length-1">
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <br>
  <!--Watchlists Section-->

</div>
